<template>
  <v-container :fluid="$vuetify.breakpoint.lgAndDown">
    <v-row>
      <v-col
        cols="12"
        md="4"
        v-if="['tablet', 'mobile'].indexOf(deviceType) !== -1"
      >
        <div style="position: sticky; top: 76px">
          <v-sheet rounded="lg" min-height="268">
            <div class="title text-center mt-3">Validations</div>
            <div class="text-center mb-3">
              {{
                this.validations &&
                this.validations.length &&
                this.validations[this.validations.length - 1].order &&
                this.validations[this.validations.length - 1].order.buyer
                  ? `Envoi commande : ${
                      this.validations[this.validations.length - 1].order.buyer
                    }`
                  : ""
              }}
            </div>
            <validation-path
              :validations="validations"
              :selectBinder="selectBinder"
              :activeIndex="activeIndex"
              :downloadFile="downloadFile"
              :downloadArchive="downloadArchive"
              :loading="loading"
            />
          </v-sheet>
        </div>
      </v-col>
      <v-col cols="12" md="8"
        ><pdf-viewer
          v-if="this.validations.length && deviceType === 'desktop'"
          :filename="filename"
        />
        <pdf-viewer-mobile
          v-if="
            this.validations.length &&
            ['tablet', 'mobile'].indexOf(deviceType) !== -1
          "
          :filename="filename"
        />
      </v-col>
      <v-col cols="12" md="4" v-if="deviceType === 'desktop'">
        <div style="position: sticky; top: 76px">
          <v-sheet rounded="lg" min-height="268">
            <div class="title text-center mt-3">Validations</div>
            <div class="text-center mb-3">
              {{
                this.validations &&
                this.validations.length &&
                this.validations[this.validations.length - 1].order &&
                this.validations[this.validations.length - 1].order.buyer
                  ? `Envoi commande : ${
                      this.validations[this.validations.length - 1].order.buyer
                    }`
                  : ""
              }}
            </div>
            <validation-path
              :validations="validations"
              :selectBinder="selectBinder"
              :activeIndex="activeIndex"
              :downloadFile="downloadFile"
              :downloadArchive="downloadArchive"
              :loading="loading"
            />
          </v-sheet>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top right>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.visible = false">
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PdfViewer from "@/components/PdfViewer";
import PdfViewerMobile from "@/components/PdfViewerMobile";
import ValidationPath from "@/components/ValidationPath";
import axios from "axios";
import { format, parseISO } from "date-fns";
import FileDownload from "js-file-download";

export default {
  components: { PdfViewer, PdfViewerMobile, ValidationPath },
  async mounted() {
    try {
      const {
        data: { validations, binder, createdBy, updatedAt, updatable },
      } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/${this.$keycloak?.resourceAccess?.["po-api"]?.roles[0]}/orders/${this.$route.params._id}/validations`,
      });
      this.validations = validations;
      this.binder = binder;
      this.createdBy = createdBy;
      this.updatedAt = updatedAt;
      this.updatable = updatable;
      this.currentValidation = this.validations.find(
        (v) =>
          [
            "pending",
            "to-order-buyer-pending",
            "to-order-contractor-pending",
          ].indexOf(v.status) !== -1 && v.type === "validation"
      );
      this.filename = this.validations[this.validations.length - 1].order
        .validatedBinder
        ? this.validations[this.validations.length - 1].order.validatedBinder
        : this.validations[this.validations.length - 1].order.binder;
      this.activeIndex =
        this.validations.map((v) => v.status).indexOf("pending") > -1
          ? this.validations.length
          : 0;
    } catch (error) {
      this.openSnackbar("Erreur de chargement", "error");
      console.log(error);
    }
  },
  props: ["updateBadge"],
  data: () => ({
    loading: false,
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
    activeIndex: 0,
    validations: [],
    binder: "",
    createdBy: {},
    updatedAt: null,
    currentValidation: {},
    filename: "",
    format,
    parseISO,
    validationSubmitted: false,
    updatable: false,
    validationUpdated: false,
  }),
  methods: {
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    selectBinder(binder, index) {
      this.filename = binder;
      this.setActiveIndex(index);
    },
    async downloadFile(filename, downloadname) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/files/${filename}`,
        responseType: "arraybuffer",
      });
      FileDownload(data, downloadname);
    },
    async downloadArchive(validationId, downloadname) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/validations/${validationId}/archive`,
        responseType: "arraybuffer",
      });
      FileDownload(data, downloadname);
    },
    openSnackbar(text, color) {
      this.snackbar = { text, color, visible: true };
    },
  },
  computed: {
    deviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      } else if (
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    },
  },
};
</script>

<style>
.fixed {
  position: fixed;
  width: 25%;
  overflow-y: scroll;
  max-height: 120%;
}
</style>